const SUNSHINE_PERSONAL_INFO_FORM_BASE =
  'https://forms.zohopublic.com/sunshinelifehealthadvisors/form/IndividualPersonalInformation1/formperma/COYTIuD9Ro7ZmkzLSDk8Sl8AIg5gOFXtgf-Pe9OGsTE';

const SUNSHINE_EO_COVERAGE_FORM_BASE =
  'https://forms.zohopublic.com/sunshinelifehealthadvisors/form/IndividualEOCoverage1/formperma/PdLcS7H1Gn-yoE7FxlSQygY3RMKpAg4AXHKNybuPUIY';

const SUNSHINE_DIRECT_DEPOSIT_FORM_BASE =
  'https://forms.zohopublic.com/sunshinelifehealthadvisors/form/IndividualDirectDepositAgreement1/formperma/2GSxNKHQ9vh9b_7BleQlvnU7uQWSLmgX-XWlxmjsi50';

export function normalizeString(v) {
  if (v == null) return '';
  return String(v);
}

/** Zoho forms expect MM/dd/yyyy in query strings (e.g. 01%2F01%2F2026). */
export function formatDateForSunshineForm(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'string') {
    const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (iso) {
      const [, y, mo, d] = iso;
      return `${mo}/${d}/${y}`;
    }
    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value.trim())) return value.trim();
  }
  return normalizeString(value);
}

function npnFromUser(user) {
  return normalizeString(user?.NPN ?? user?.NPN_Text_Field ?? '');
}

function agentOwnerFromUser(user) {
  return normalizeString(user?.Owner?.id ?? '');
}

export function sunshinePersonalInfoFormUrl(user) {
  const npn = npnFromUser(user);
  const params = new URLSearchParams();

  params.set('npn', npn);
  params.set('Agent_Owner', agentOwnerFromUser(user));
  params.set('crmnpn', npn);
  params.set('First_Name', normalizeString(user?.First_Name));
  params.set('Middle_Name', normalizeString(user?.Middle_Name));
  params.set('Last_Name', normalizeString(user?.Last_Name));
  params.set('Preferred_First_Name', normalizeString(user?.Nickname));
  params.set('Street_Address', normalizeString(user?.Mailing_Street));
  params.set('Address_Line_2', normalizeString(user?.Mailing_Street_2));
  params.set('City', normalizeString(user?.Mailing_City ?? user?.City));
  params.set('State', normalizeString(user?.Mailing_State ?? user?.State));
  params.set('ZipCode', normalizeString(user?.Mailing_Zip ?? user?.ZIP_Code));
  params.set('County', normalizeString(user?.County));
  params.set('Phone', normalizeString(user?.Phone ?? user?.Secondary_Phone));
  params.set(
    'Preferred_Email_Language',
    normalizeString(user?.Preferred_Email_Language)
  );
  params.set('Email', normalizeString(user?.Email));
  params.set('FFM_ID', normalizeString(user?.FFMIG_Number));
  params.set('DoB', formatDateForSunshineForm(user?.Date_of_Birth));
  params.set('Gender', normalizeString(user?.Sex));

  const languages = user?.Languages;
  if (Array.isArray(languages)) {
    for (const lang of languages) {
      if (lang != null && lang !== '')
        params.append('Languages', normalizeString(lang));
    }
  }

  params.set('Bussines_Name', normalizeString(user?.Business_Name));
  params.set(
    'Personal_Business_FEIN',
    normalizeString(user?.Personal_Business_FEIN)
  );

  return `${SUNSHINE_PERSONAL_INFO_FORM_BASE}?${params.toString()}`;
}

export function sunshineEOCoverageFormUrl(user) {
  const params = new URLSearchParams();

  params.set('First_Name', normalizeString(user?.First_Name));
  params.set('Last_Name', normalizeString(user?.Last_Name));
  params.set('npn', npnFromUser(user));
  params.set(
    'Preferred_Email_Language',
    normalizeString(user?.Preferred_Email_Language)
  );
  params.set('Agent_Owner', agentOwnerFromUser(user));
  params.set('E_OCoverageCarrier', normalizeString(user?.E_O_Coverage_Carrier));
  params.set('PolicyNumber', normalizeString(user?.Policy_Number));
  params.set(
    'E_OExpirationDate',
    formatDateForSunshineForm(user?.E_O_Expiration_Date)
  );
  params.set('AmountPerClaim', normalizeString(user?.Amount_Per_Claim));
  params.set('AmountAggregate', normalizeString(user?.Amount_Aggregate));

  return `${SUNSHINE_EO_COVERAGE_FORM_BASE}?${params.toString()}`;
}

export function sunshineDirectDepositFormUrl(user) {
  const params = new URLSearchParams();

  params.set('First_Name', normalizeString(user?.First_Name));
  params.set('Last_Name', normalizeString(user?.Last_Name));
  params.set('npn', npnFromUser(user));
  params.set(
    'Preferred_Email_Language',
    normalizeString(user?.Preferred_Email_Language)
  );
  params.set('Agent_Owner', agentOwnerFromUser(user));
  params.set('Account_Type', normalizeString(user?.Account_Type));
  params.set(
    'Name_on_Account',
    normalizeString(user?.Name_on_Account ?? user?.Name1)
  );
  params.set('Business_Name', normalizeString(user?.Business_Name));
  params.set(
    'Name_of_Financial_Institution',
    normalizeString(user?.Name_of_Financial_Institution)
  );
  params.set('Routing_Number', normalizeString(user?.Routing_Number));
  params.set('Routing_Type', normalizeString(user?.Routing_Number_Type));
  params.set('Account_Number', normalizeString(user?.Account_Number));
  params.set(
    'Is_this_a_joint_account',
    normalizeString(user?.Is_this_a_joint_account)
  );

  return `${SUNSHINE_DIRECT_DEPOSIT_FORM_BASE}?${params.toString()}`;
}
